export const LMS_ASSIGNMENTS_RESET_STATE = 'LMS_ASSIGNMENTS_RESET_STATE';
export const LMS_ASSIGNMENTS_CURRENT_ITEM = 'LMS_ASSIGNMENTS_CURRENT_ITEM';

export const LMS_ASSIGNMENTS_REQUEST_LOADING = 'LMS_ASSIGNMENTS_REQUEST_LOADING';
export const LMS_ASSIGNMENTS_REQUEST_SUCCESS = 'LMS_ASSIGNMENTS_REQUEST_SUCCESS';
export const LMS_ASSIGNMENTS_REQUEST_FAILED = 'LMS_ASSIGNMENTS_REQUEST_FAILED';

export const LMS_ASSIGNMENTS_CURRENT_ACTION = 'LMS_ASSIGNMENTS_CURRENT_ACTION';
export const LMS_ASSIGNMENTS_RESET_ACTION = 'LMS_ASSIGNMENTS_RESET_ACTION';
